var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUphill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 55,
    viewBox: "0 0 127 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4988 35.1088L15.1542 31.8977C16.1689 26.9256 14.2938 21.8062 10.3078 18.6657L6.47624 15.6469C3.54113 13.3344 3.00938 9.09239 5.28288 6.12695C7.4713 3.27249 11.4985 2.60457 14.4913 4.59973L24.3766 11.19C24.5619 11.3135 24.7379 11.4502 24.9034 11.5991L29.6783 15.8965C36.204 21.7697 46.3497 15.4527 43.9589 7.00501C43.4612 5.24669 44.7822 3.5 46.6096 3.5H58.2518C60.9279 3.5 63.5168 4.45163 65.5559 6.18481L69.1877 9.27184C69.8776 9.8583 70.2184 10.7577 70.0904 11.6542C68.8317 20.4652 80.1106 25.1906 85.5084 18.1137L92.3156 9.18866C93.3675 7.8094 95.0028 7 96.7375 7H107.987C111.86 7 115 10.1398 115 14.013C115 16.1355 115.519 18.2258 116.512 20.1016L123.432 33.1716C123.805 33.8766 124 34.6621 124 35.4598V40.8913C124 43.5935 120.63 44.8279 118.885 42.765C114.638 37.7454 106.601 38.9057 103.947 44.9217L103.736 45.3994C102.848 47.4125 100.25 47.966 98.6182 46.4898L98.3554 46.2521C95.0687 43.2784 90.1604 42.978 86.5356 45.5288L83.6835 47.5359C80.9157 49.4836 77.2109 49.4371 74.4929 47.4205L72.9552 46.2796C67.3819 42.1446 59.5299 43.1971 55.2424 48.6539C53.195 51.2597 49.57 52.0151 46.6523 50.444L31.3012 42.178C28.3999 40.6158 24.9708 40.3626 21.8716 41.4817C17.769 42.9633 13.6266 39.3826 14.4988 35.1088Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUphill1);
export default __webpack_public_path__ + "static/media/uphill1.11bd70f1.svg";
export { ForwardRef as ReactComponent };